import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButtonProps, AppActions } from './types';
import { CoreButton } from '@clover/web-lib-core/components';
import { Uuid } from '../../../models/common';
import { NotificationVariant } from '../../Common/Notifications/types';
import { useFlagReviewMutation } from '../../../redux/api/appMarket-api-slice';
import { FlagReviewResponse } from '../../../models/post-req-responses-payloads';
import { TextButton } from '../../Common/TextButton';

interface ComponentProps extends ActionButtonProps<FlagReviewResponse>{
  appId: Uuid;
  reviewId: Uuid;
}

export const ReportReviewButton: React.FC<ComponentProps> = (
  {
    appId,
    reviewId,
    text,
    buttonVariant,
    actionCallBack,
    isMenuItem
  }): Nullable<JSX.Element> => {
  const [flagAppReview] = useFlagReviewMutation();
  const { t } = useTranslation();
  const buttonText = text || t(AppActions.FlagReview);

  const reportReview = async () => {
    const reqResponse = await flagAppReview({ appId, reviewId });
    actionCallBack?.({
      reqResponse,
      successNotification: {
        variant: NotificationVariant.Blue,
        title: 'app_actions.banners.review_flagged',
      }
    });
  };

  return (
    isMenuItem ?
      <TextButton onClick={reportReview} text={buttonText!} /> :
      <CoreButton
        variant={buttonVariant}
        onClick={reportReview}>
        {buttonText}
      </CoreButton>
  );
};
